"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueueRouteOutboundExtension = void 0;
const getQueueRouteOutboundExtension = (queue_id, voice_route_id) => {
    return `queue-${(queue_id + "").padStart(7, "0")}-route-${(voice_route_id + "").padStart(7, "0")}-`;
};
exports.getQueueRouteOutboundExtension = getQueueRouteOutboundExtension;
